"use client";

import { Page, SiteConfig } from "@/contents/sanityTypes"
import { PageMetadata } from "@/modules/seo/PageMetadata"

export interface SbPageSEOProps {
  settings: SiteConfig
  content: Page
  pageUrl: string
}

const SanityPageSEO = ({ settings, content, pageUrl }: SbPageSEOProps) => {
  return (
    <PageMetadata
      title={[
        content?.seo?.metaTitle ?? "",
        (settings.seoConfig as any)?.siteTitle,
      ].join(" | ")}
      description={content?.seo?.metaDescription ?? ""}
      siteName={(settings.seoConfig as any)?.siteTitle ?? ""}
      cover={(settings.seoConfig as any)?.cover as unknown as string}
      icon={(settings.seoConfig as any)?.favicon as unknown as string}
      noFollow={content?.seo?.noFollow}
      noIndex={content?.seo?.noIndex}
      url={pageUrl}
    />
  )
}

export default SanityPageSEO
